<template>
  <div class="modal">
    <el-dialog :title="title" :visible="showModal" width="600px" top="3vh" :close-on-click-modal="false"
        :modal="true" :append-to-body="true" @close="closeModal">
      <div class="modal__image_wrapper">
        <div class="modal__logo">
          <div class="modal__image--title">Logo Image</div>
          <div v-if="!logo && !previewLogo" class="modal__image--uploader">
            <label for="logoFile" class="modal__image-uploader"><i class="el-icon-plus fa-2x"></i></label>
            <input type="file" id="logoFile" v-show="false" @change="uploadLogo">
          </div>
          <div v-else class="modal__image--preview">
            <img height="120" width="120" :src="logo ? brand.logo : previewLogo" alt="logo">
            <div class="overlay"> <i @click="removeLogo" class="el-icon-delete fa-2x" /> </div>
          </div>
        </div>
        <div class="modal__image">
          <div class="modal__image--title">Campaign Image</div>
          <div v-if="!image && !previewImage" class="modal__image--uploader">
            <label for="imageFile" class="modal__image-uploader"><i class="el-icon-plus fa-2x"></i></label>
            <input type="file" id="imageFile" v-show="false" @change="uploadImage">
          </div>
          <div v-else class="modal__image--preview">
            <img height="120" width="120" :src="image ? brand.image : previewImage" alt="image">
            <div class="overlay"> <i @click="removeImage" class="el-icon-delete fa-2x" /> </div>
          </div>
        </div>
      </div>
      <el-form ref="brand">
        <el-switch class="modal__featured" v-model="brand.featured" active-text="Featured" inactive-text="Not Featured"
                   active-color="#13ce66" inactive-color="#df2758"></el-switch>
        <el-form-item label=" Product name">
          <el-input v-model="brand.name"></el-input>
        </el-form-item>
        <el-form-item label="Company name">
          <el-input v-model="brand.company_name"></el-input>
        </el-form-item>
        <el-switch class="modal__affiliate" v-model="brand.affiliate_signup_generator" active-text="Affiliate link generator" inactive-text=""
                   active-color="#13ce66" inactive-color="#df2758"></el-switch>
        <div class="modal__platforms">
          <el-form-item label="Platforms">
             <el-select v-model="brand.socials" filterable multiple>
               <el-option v-for="social in filteredSocials" :key="social.id" :value="social.id" :label="social.name">
               </el-option>
             </el-select>
          </el-form-item>
        </div>
        <Challenge v-if="hasSocial('YouTube')" type="youtube_regular"
                   @challengeVideo="uploadChallengeVideo" />
        <Challenge v-if="hasSocial('YouTube Short')" type="short_challenge"
                   @challengeVideo="uploadChallengeVideo" />
        <Challenge v-if="hasSocial('TikTok')" type="tiktok_challenge"
                   @challengeVideo="uploadChallengeVideo" />
        <Challenge v-if="hasSocial('Instagram')" type="instagram_challenge"
                   @challengeVideo="uploadChallengeVideo" />
        <el-form-item label="Blue box text" prop="card_bar_desc">
          <div class="vue_editor">
            <vue-editor
              placeholder="Enter text for card bar..."
               id="editor"
               v-model="brand.card_bar_desc"
              :editorToolbar="customToolbar"/>
          </div>
        </el-form-item>
        <el-form-item label="Campaign hook">
          <el-input  placeholder="Campaign hook" v-model="brand.description"></el-input>
        </el-form-item>
        <el-form-item class="modal__smart-links" label="Smart links">
          <div class="smart_links_content">
            <el-button @click="addSmartLink" size="mini">Add Smart Link</el-button>
            <el-button class="modal__assets--btn" type="default" @click="showSmartLinks = !showSmartLinks"
                       :icon="showSmartLinks === true ? 'el-icon-top' : 'el-icon-bottom'"
                       circle></el-button>
            <small>(You can add max 3 smart links)</small>
            </div>
        </el-form-item>
        <div v-if="showSmartLinks">
          <div v-for="(link, index) in brand.smartLinks" :key="link.key">
            <el-form-item class="modal__smart-links--input" :label="`Smart Link ${index + 1}`"
                          :prop="'smartLinks.' + index + 'value'">
              <el-input v-model="link.value"></el-input>
              <el-button @click.prevent="removeSmartLink(link)" size="mini">Delete</el-button>
            </el-form-item>
            <!--          <el-form-item class="smart-link-input" :label="`Smart Link Description ${index + 1}`"
                                    :prop="'smartLinks.' + index + 'description'" >
                        <el-input v-model="link.description"></el-input>
                      </el-form-item>-->
          </div>
        </div>
<!--        <el-form-item label="Select Restrictions" prop="restrictions">
          <el-button class="modal__assets&#45;&#45;btn" type="default" @click="showRestrictions = !showRestrictions"
                     :icon="showRestrictions === true ? 'el-icon-top' : 'el-icon-bottom'"
                     circle></el-button>
          <div v-if="showRestrictions" class="modal__restrictions">
            <div>
              <el-checkbox-group v-model="brand.restrictions">
                <el-checkbox v-for="r in restrictionNames.slice(0, Math.ceil(restrictionNames.length / 2))"
                             :key="new Date().getTime() + r" :label="r"></el-checkbox>
              </el-checkbox-group>
            </div>
            <div>
              <el-checkbox-group v-model="brand.restrictions">
                <el-checkbox v-for="r in restrictionNames.slice(Math.ceil(restrictionNames.length / 2), restrictionNames.length)"
                             :key="new Date().getTime() + r" :label="r"></el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>-->
<!--        <el-form-item class="modal__assets" label="Assets">
          <el-button class="modal__assets&#45;&#45;btn" type="default" @click="showAssets = !showAssets"
                     :icon="showAssets === true ? 'el-icon-top' : 'el-icon-bottom'"
                     circle></el-button>
          <div v-if="showAssets" class="modal__assets&#45;&#45;content">
            <div class="uploader">
              <label for="assetUpload"><i class="el-icon-plus fa-lg"></i></label>
              <input v-show="false" type="file" id="assetUpload" @change="uploadAsset">
            </div>
            <div class="list-item">
              <ul>
                <li v-for="asset in assets.concat(previewAssets)" :key="asset.id">
                  <img class="list-item__image" :src="asset.type === 2 ? videoImage() : asset.path" alt="asset">
                  <a class="list-item__name"
                  >{{ asset.path.length > 40 ? asset.path.split('/').reverse()[0].slice(0, 40) + '...' : asset.path.split('/').reverse()[0] }}
                  </a>
                  <div class="list-item__delete"></div>
                  <i class="list-item__delete&#45;&#45;icon el-icon-close" @click="removeAsset(asset.id)"></i>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>-->
        <el-form-item label="Timing" class="mt20">
          <el-date-picker v-model="timing" type="daterange" format="d MMMM yyyy" value-format="yyyy-MM-dd"
                          range-separator="-" start-placeholder="Start Date" end-placeholder="End Date"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" size="mini" :loading="loading" @click="save"> Save </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Challenge from "@/modules/admin/brand/components/Challenge.vue";
import {VueEditor} from "vue2-editor";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "Modal",

  data() {
    return {
      showAssets: false,
      showRestrictions: false,
      showSmartLinks: false,
      selectedImage: null,
      selectedLogo: null,
      selectedAssets: [],
      previewAssets: [],
      previewImage: null,
      previewLogo: null,
      short_challenge_video: null,
      youtube_regular_video: null,
      tiktok_challenge_video: null,
      instagram_challenge_video: null,
      customToolbar: [
        ["bold"]
      ],
      excludedSocialId: 3 //youtube regular
    }
  },
  components: { Challenge, VueEditor },

  computed: {
    ...mapState('brand', ['modalAction', 'brand', 'socials', 'showModal', 'loading', 'restrictions']),

    timing: {
      get() {
        if (this.brand.start_date && this.brand.end_date) {
         return [this.brand.start_date, this.brand.end_date]
        }
        return null
      },
      set(value) {
        if (Array.isArray(value) && value.length === 2) this.setTiming(value)
        else this.setTiming([null, null])
      }
    },

    restrictionNames() {
      return this.restrictions.map(r => r.name)
    },

    title() {
      if (this.modalAction === 'create') return 'Create new brand'
      else if (this.modalAction === 'update') return 'Edit brand'
      return ''
    },

    assets() {
      if (!this.brand.assets) return []
      return this.brand.assets.filter(a => !(a.path instanceof File))
    },

    image() {
      return this.brand.image instanceof File ? null : this.brand.image
    },

    logo() {
      return this.brand.logo instanceof File ? null : this.brand.logo
    },
    filteredSocials() {
      return this.socials.filter(social => social.id);
    }
  },

  methods: {
    ...mapMutations('brand', [
        'setTiming', 'setModal', 'setSmartLinks', 'setImage', 'setLogo', 'setBrand'
    ]),
    ...mapActions('brand', ['createOrUpdateBrand']),

    uploadChallengeVideo(value) {
      this[value.type + '_video'] = value.file
    },

    hasSocial(platform) {
      const findPlatform = this.socials.find(p => p.name === platform)

      return  this.brand.socials && !!this.brand.socials.find(p => p === findPlatform.id)
    },

    closeModal() {
      this.setModal(false)
      this.setBrand({})
      Object.assign(this.$data, this.$options.data())
    },

    videoImage() {
      return require('@/assets/images/video.svg')
    },

    addSmartLink() {
      if (this.brand.smartLinks.length === 3) return

      this.showSmartLinks = true

      this.brand.smartLinks.push({key: new Date().getTime(), value: ''})
      this.setSmartLinks(this.brand.smartLinks)
    },

    removeSmartLink(link) {
      const index = this.brand.smartLinks.indexOf(link);

      if (index !== -1) {
        this.brand.smartLinks.splice(index, 1);
      }
      this.setTrackSmartLinks(this.brand.smartLinks)
    },

    uploadImage(event) {
      this.selectedImage = event.target.files[0]
      this.previewImage = URL.createObjectURL(event.target.files[0])
    },

    removeImage() {
      this.setImage(null)
      this.selectedImage = null
      this.previewImage = null
    },

    uploadLogo(event) {
      this.selectedLogo = event.target.files[0]
      this.previewLogo = URL.createObjectURL(event.target.files[0])
    },
    removeLogo() {
      this.setLogo(null)
      this.selectedLogo = null
      this.previewLogo = null
    },

    save() {
      if (this.selectedImage) this.setImage(this.selectedImage)

      if (this.selectedLogo) this.setLogo(this.selectedLogo)

      if (this.short_challenge_video) this.brand.short_challenge.video = this.short_challenge_video
      if (this.youtube_regular_video) this.brand.youtube_regular.youtube_video = this.youtube_regular_video
      if (this.tiktok_challenge_video) this.brand.tiktok_challenge.video = this.tiktok_challenge_video
      if (this.instagram_challenge_video) this.brand.instagram_challenge.video = this.instagram_challenge_video

      this.createOrUpdateBrand()
    },
  }
}
</script>

<style scoped lang="scss">
.modal {
  &__image_wrapper{
    display: flex;
    justify-content: space-evenly;
  }
  &__image {
    &--title{
      font-size: 16px;
      color: #0E0525;
      line-height: 23px;
      min-height: 45px;
    }
    &--uploader {
      label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        width: 120px;
        height: 120px;
        border: 1px dashed #d9d9d9;
        cursor: pointer;
      }
    }
    &--preview {
      text-align: center;
      position: relative;

      &:hover {
        .overlay {
          display: flex;
        }
      }

      .overlay {
        position: absolute;
        z-index: 5;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 120px;
        height: 100%;
        background: rgba(0, 0, 0, .1);
        display: none;
        align-items: center;
        justify-content: center;
        i {
          cursor: pointer;
        }
      }
    }
  }
  &__featured {
    display: block;
    text-align: center;
    margin-top: 15px;
  }
  &__affiliate{
    display: block;
    margin-top: 15px;
  }
  &__platforms {
    display: flex;
  }
  &__restrictions {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;

    label.el-checkbox {
      min-height: 30px;
    }
  }
  &__smart-links {
    .smart_links_content{
      width: 100%;
      display: flex;
    }
    small {
      margin-left: 10px;
    }
    &--input {
      .el-input {
        width: 80%;
        margin-right: 10px;
      }
    }
  }
  label.el-checkbox {
    display: inline-block;
  }

  &__assets {
    &--btn {
      height: 25px;
      width: 25px;
      padding: 0;
      margin-top: 10px;
    }
    &--content {
     position: relative;
     width: 100%;
     display: flex;
     flex-direction: column;

     .uploader {
       label {
         border: 1px dashed #d9d9d9;
         display: flex;
         justify-content: center;
         align-items: center;
         cursor: pointer;

         &:hover {
           border-color: #e55279;

           i {
             color: #e55279;
           }
         }
       }
      }
      .list-item {

        &__image {
          width: 50px;
          height: 50px;
          float: left;
          position: relative;
          z-index: 1;
          margin-left: -80px;
          background-color: #fff;
          border-radius: 6px;
        }
        &__name {
          line-height: 50px;
        }
        &__delete {
          position: absolute;
          right: -17px;
          top: -7px;
          width: 46px;
          height: 26px;
          background: #c0ccda;
          text-align: center;
          transform: rotate(45deg);
          box-shadow: 0 1px 1px #ccc;

          &--icon {
            position: absolute;
            color: white;
            cursor: pointer;
            top: 2px;
            right: 2px;
          }
        }
        ul {
          margin: 0;
          padding: 0;
          li {
            position: relative;
            list-style: none;
            overflow: hidden;
            background-color: #fff;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            margin-top: 10px;
            padding: 10px 10px 10px 90px;
            height: 72px;
          }
        }
      }
    }
  }
}
.vue_editor{
  height: 100px;
  margin-top: 46px;
  border-bottom:1px solid rgb(204, 204, 204);
  //border-top:1px solid rgb(204, 204, 204);
  overflow: hidden;
  :deep(.quillWrapper){
    height: 110px;
    :deep(.ql-editor){
      height: 100px;
    }
  }
}
#editor{
  height: 50px !important;
}
</style>
